import React from "react";
import { COLORS, TextField } from "components";
import { ColorType } from "types";
import { FieldConfig } from "../../types";

export const InputTextField = ({ field }: { field: FieldConfig }) => <TextField
    key={field.key}
    sxLabel={{ color: COLORS.Mainblue }}
    color={'primary' as ColorType}
    sx={{
        width: '100%',
        "& .MuiInputBase-root.MuiOutlinedInput-root": { fontSize: '12px', border: '0px', "& .MuiOutlinedInput-notchedOutline": { borderRadius: '8px', borderWidth: '1px' } }
    }}
    onChange={(e) => field.onChange(e.target.value)}
    placeholder={field.placeholder}
    value={field.value}
    label={field.label}
    variant="outlined"
/>